import { useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, CheckCircle2, UserPlus } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function HangaroundIntake() {
  const [form, setForm] = useState({ name: "", handle: "", phone: "", email: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await axios.post(`${BACKEND_URL}/api/hangaround-intake`, form);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong — please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-slate-800/70 border-slate-700">
        <CardHeader className="text-center pb-2">
          <img src="/brothers-logo.png" alt="BOH" className="w-20 h-20 mx-auto mb-2 object-contain" onError={(e) => { e.target.style.display = "none"; }} />
          <CardTitle className="text-white text-xl flex items-center justify-center gap-2">
            <UserPlus className="w-5 h-5 text-amber-500" /> Hangaround Intake
          </CardTitle>
          <p className="text-slate-400 text-sm">Brothers of the Highway — tell us who you are</p>
        </CardHeader>
        <CardContent>
          {done ? (
            <div className="text-center py-8 space-y-3" data-testid="intake-success">
              <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
              <p className="text-white font-semibold text-lg">You're on the list!</p>
              <p className="text-slate-400 text-sm">Your info has been received. Someone from the club will be in touch.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-2">
              <div>
                <Label className="text-slate-300">Name *</Label>
                <Input value={form.name} onChange={set("name")} required maxLength={100}
                  placeholder="Your full name" className="bg-slate-700 border-slate-600 text-white"
                  data-testid="intake-name-input" />
              </div>
              <div>
                <Label className="text-slate-300">Handle *</Label>
                <Input value={form.handle} onChange={set("handle")} required maxLength={100}
                  placeholder='Your CB handle / nickname / "None"' className="bg-slate-700 border-slate-600 text-white"
                  data-testid="intake-handle-input" />
              </div>
              <div>
                <Label className="text-slate-300">Phone Number *</Label>
                <Input value={form.phone} onChange={set("phone")} required maxLength={30} type="tel"
                  placeholder="(555) 555-5555" className="bg-slate-700 border-slate-600 text-white"
                  data-testid="intake-phone-input" />
              </div>
              <div>
                <Label className="text-slate-300">Email *</Label>
                <Input value={form.email} onChange={set("email")} required maxLength={100} type="email"
                  placeholder="you@example.com" className="bg-slate-700 border-slate-600 text-white"
                  data-testid="intake-email-input" />
              </div>
              {error && <p className="text-red-400 text-sm" data-testid="intake-error">{error}</p>}
              <Button type="submit" disabled={submitting}
                className="w-full bg-amber-600 hover:bg-amber-700 text-white" data-testid="intake-submit-btn">
                {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Submit"}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
